import {
  FETCH_EASY_JOIN_CODES_START,
  FETCH_EASY_JOIN_CODES_FULFILLED,
  FETCH_EASY_JOIN_CODES_REJECTED,
  CREATE_EASY_JOIN_CODE_START,
  CREATE_EASY_JOIN_CODE_FULFILLED,
  CREATE_EASY_JOIN_CODE_REJECTED,
  UPDATE_EASY_JOIN_CODE_START,
  UPDATE_EASY_JOIN_CODE_FULFILLED,
  UPDATE_EASY_JOIN_CODE_REJECTED,
  DELETE_EASY_JOIN_CODES_START,
  DELETE_EASY_JOIN_CODES_FULFILLED,
  DELETE_EASY_JOIN_CODES_REJECTED,
  EASY_JOIN_CLEAR_LAST_CREATED,
  EASY_JOIN_CLEAR_LAST_UPDATED,
} from './actionTypes';

import { axiosAuthed } from '../../../shared/utils/setCommonHeaders';
import { showSuccessToast, showErrorToast } from '../../../shared/utils/toastManager';

export const fetchEasyJoinCodes = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_EASY_JOIN_CODES_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/easy-joins`)
    .then((response) => {
      dispatch({ type: FETCH_EASY_JOIN_CODES_FULFILLED, payload: response.data });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_EASY_JOIN_CODES_REJECTED,
        payload: error?.response?.headers?.message || 'Failed to load Easy Join codes',
      });
      showErrorToast(error?.response?.headers?.message || 'Failed to load Easy Join codes. Please try again.');
    });
};

export const createEasyJoinCode = (accountCode, values) => (dispatch) => {
  dispatch({ type: CREATE_EASY_JOIN_CODE_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/easy-joins`, values)
    .then((response) => {
      dispatch({ type: CREATE_EASY_JOIN_CODE_FULFILLED, payload: response.data });
      showSuccessToast('New Easy Join code created!');
    })
    .catch((error) => {
      dispatch({
        type: CREATE_EASY_JOIN_CODE_REJECTED,
        payload: error?.response?.headers?.message || 'Failed to create Easy Join code',
      });
      showErrorToast(error?.response?.headers?.message || 'Failed to create Easy Join code.');
    });
};

export const updateEasyJoinCode = (accountCode, easyJoinId, values) => (dispatch) => {
  dispatch({ type: UPDATE_EASY_JOIN_CODE_START });
  axiosAuthed
    .put(`/accounts/${accountCode}/easy-joins/${easyJoinId}`, values)
    .then((response) => {
      dispatch({ type: UPDATE_EASY_JOIN_CODE_FULFILLED, payload: response.data });
      showSuccessToast('Easy Join code updated.');
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_EASY_JOIN_CODE_REJECTED,
        payload: error?.response?.headers?.message || 'Failed to update Easy Join code',
      });
      showErrorToast(error?.response?.headers?.message || 'Failed to update Easy Join code.');
    });
};

export const deleteEasyJoinCodes = (accountCode, easyJoinIds) => (dispatch) => {
  dispatch({ type: DELETE_EASY_JOIN_CODES_START });
  axiosAuthed
    .patch(`/accounts/${accountCode}/easy-joins/delete`, { easyJoinIds })
    .then(() => {
      dispatch({ type: DELETE_EASY_JOIN_CODES_FULFILLED, payload: easyJoinIds });
      const count = easyJoinIds.length;
      showSuccessToast(`Easy Join code${count !== 1 ? 's' : ''} deleted.`);
    })
    .catch((error) => {
      dispatch({
        type: DELETE_EASY_JOIN_CODES_REJECTED,
        payload: error?.response?.headers?.message || 'Failed to delete Easy Join code(s)',
      });
      showErrorToast(error?.response?.headers?.message || 'Failed to delete Easy Join code(s).');
    });
};

export const clearLastCreated = () => ({ type: EASY_JOIN_CLEAR_LAST_CREATED });
export const clearLastUpdated = () => ({ type: EASY_JOIN_CLEAR_LAST_UPDATED });
